import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    stepWizardContainer: {},
  }),
  {index: 1},
);

export default useStyles;
